<template>
  <div class="container-fluid" style="padding: 20px 0">
    <div class="row">
      <div class="col">
        <div class="page-title m-plus-medium">画像確認</div>
      </div>
    </div>
    <div v-if="isLoading">Loading...</div>
    <div v-else class="row" style="margin-top: 10px">
      <div
        class="col-4"
        style="margin-top: 15px"
        v-for="(image, index) in images"
        :key="index"
      >
        <div class="card" style="border: 0 !important">
          <div>
            <img :src="image.url" alt="Firebase Image" class="card-img-top" />
          </div>
          <div class="card-body">
            <p class="path">{{ image.path }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storage } from "../../plugins/firebase";
import { ref, listAll, getDownloadURL } from "firebase/storage";

export default {
  data() {
    return {
      images: [], // 画像のURLとパスを格納
      isLoading: true, // ローディング状態
    };
  },
  async mounted() {
    await this.listImages();
  },
  methods: {
    async listImages() {
      try {
        const storageRef = ref(
          storage,
          "gs://" + process.env.VUE_APP_STORAGE_BUCKET,
        ); // ルートパスを参照
        const result = await this.recursiveList(storageRef); // Storage内のすべてのアイテムを列挙

        const imagePromises = result.map(async (item) => {
          const url = await getDownloadURL(item); // 画像のダウンロードURLを取得
          return { path: item.fullPath, url }; // URLとパスを返す
        });

        this.images = await Promise.all(imagePromises); // すべての画像情報を取得
      } catch (error) {
        console.error("Error listing images:", error);
      } finally {
        this.isLoading = false; // ローディング完了
      }
    },
    async recursiveList(directoryRef) {
      const result = await listAll(directoryRef);
      let items = [...result.items]; // 現在のディレクトリ内のファイルを追加

      // サブディレクトリを再帰的に探索
      const subdirectoryPromises = result.prefixes.map((folderRef) =>
        this.recursiveList(folderRef),
      );
      const subdirectoryItems = await Promise.all(subdirectoryPromises);

      // サブディレクトリ内のアイテムをフラットに結合
      subdirectoryItems.forEach((subItems) => {
        items = items.concat(subItems);
      });

      return items;
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 30px;
  font-weight: bold;
  color: #827490;
}
</style>
